export class ModuleCard {
  public static readonly ASSET_GROUP = new ModuleCard(
    'MODULE.ASSET_GROUP',
    'ASSET_GROUP',
    {
      fontSet: 'material-symbols-outlined',
      icon: 'home_work'
    },
    ['asset-groups']
  );
  public static readonly ASSET = new ModuleCard(
    'MODULE.ASSET',
    'ASSET',
    {
      fontSet: 'mdi',
      icon: 'mdi-city'
    },
    ['assets']
  );
  public static readonly GRAPH = new ModuleCard(
    'MODULE.GRAPH',
    'GRAPH',
    {
      fontSet: 'mdi',
      icon: 'mdi-finance'
    },
    ['graph', 'view']
  );
  public static readonly PROJECT = new ModuleCard(
    'MODULE.PROJECT',
    'PROJECT',
    {
      fontSet: 'mdi',
      icon: 'mdi-office-building-cog-outline'
    },
    ['projects', 'inventory']
  );
  public static readonly MEETING = new ModuleCard(
    'MODULE.MEETING',
    'MEETING',
    {
      fontSet: 'mdi',
      icon: 'mdi-file-chart'
    },
    ['meetings', 'inventory']
  );
  public static readonly INVESTMENT = new ModuleCard(
    'MODULE.INVESTMENT',
    'INVESTMENT',
    {
      fontSet: 'mdi',
      icon: 'mdi-currency-usd'
    },
    ['investments', 'inventory']
  );
  public static readonly DOCUMENT = new ModuleCard(
    'MODULE.DOCUMENT',
    'DOCUMENT',
    {
      fontSet: 'mdi',
      icon: 'mdi-file-document-outline'
    },
    ['documents', 'inventory']
  );
  public static readonly CONFIG_ORG = new ModuleCard(
    'MODULE.CONFIGURATION',
    'ORGANIZATION',
    {
      fontSet: 'mdi',
      icon: 'mdi-cog'
    },
    ['configuration']
  );
  public static readonly RIGHT = new ModuleCard(
    'MODULE.MANAGE_RIGHTS',
    'RIGHT',
    {
      fontSet: 'mdi',
      icon: 'mdi-shield-account'
    },
    ['clients']
  );
  public static readonly CHECK = new ModuleCard(
    'MODULE.CHECK',
    'CHECK',
    {
      fontSet: 'mdi',
      icon: 'mdi-clipboard-check-outline'
    },
    ['checks']
  );
  public static readonly CONTRACT = new ModuleCard(
    'MODULE.CONTRACT',
    'CONTRACT',
    {
      fontSet: 'mdi',
      icon: 'mdi-clipboard-text-outline'
    },
    ['contracts']
  );
  public static readonly OCCUPANT = new ModuleCard(
    'MODULE.OCCUPANT',
    'OCCUPANT',
    {
      fontSet: 'mdi',
      icon: 'mdi-clipboard-account-outline'
    },
    ['occupants']
  );
  public static readonly SPACE = new ModuleCard(
    'MODULE.SPACE',
    'SPACE',
    {
      fontSet: 'mdi',
      icon: 'mdi-domain'
    },
    ['spaces']
  );
  public static readonly EQUIPMENT = new ModuleCard(
    'MODULE.EQUIPMENT',
    'EQUIPMENT',
    {
      fontSet: 'mdi',
      icon: 'mdi-wrench-cog-outline'
    }
  );
  public static readonly WORK = new ModuleCard(
    'MODULE.WORK',
    'WORK',
    {
      fontSet: 'mdi',
      icon: 'mdi-hammer-wrench'
    },
    ['works']
  );
  public static readonly VIRTUAL_TOUR = new ModuleCard(
    'MODULE.VIRTUAL_TOUR',
    'VIRTUAL_TOUR',
    {
      fontSet: 'mdi',
      icon: 'mdi-home-map-marker'
    },
    ['virtual-tours']
  );
  public static readonly JMAP = new ModuleCard(
    'MODULE.JMAP',
    'JMAP',
    {
      fontSet: 'mdi',
      icon: 'mdi-map-legend'
    },
    ['jmap']
  );
  public static readonly CARTOVISTA = new ModuleCard(
    'MODULE.CARTOVISTA',
    'CARTOVISTA',
    {
      fontSet: 'mdi',
      icon: 'mdi-map-legend'
    },
    ['cartovista']
  );
  public static readonly CRV = new ModuleCard(
    'MODULE.CRV',
    'CRV',
    {
      fontSet: 'mdi',
      icon: 'mdi-home-analytics'
    }
  );
  public static readonly RISK = new ModuleCard(
    'MODULE.RISK',
    'RISK',
    {
      fontSet: 'mdi',
      icon: 'mdi-alert'
    }
  );
  public static readonly BI_REPORT = new ModuleCard(
    'MODULE.BI_REPORT',
    'BI_REPORT',
    {
      fontSet: 'mdi',
      icon: 'mdi-file-chart'
    }
  );
  public static readonly ASSET_AUDIT = new ModuleCard(
    'MODULE.ASSET_AUDIT',
    'ASSET_AUDIT',
    {
      fontSet: 'mdi',
      icon: 'mdi-tools'
    }
  );
  public static readonly FILE_REPOSITORY = new ModuleCard(
    'MODULE.FILE_REPOSITORY',
    'FILE_REPOSITORY',
    {
      fontSet: 'mdi',
      icon: 'mdi-file-cloud-outline'
    },
    ['files']
  );
  public static readonly SNAPSHOT = new ModuleCard(
    'MODULE.SNAPSHOT',
    'SNAPSHOT',
    {
      fontSet: 'mdi',
      icon: 'mdi-folder-multiple'
    }
  );
  public static readonly RETOOL_APP = new ModuleCard(
    'MODULE.RETOOL_APP',
    'RETOOL_APP',
    {
      fontSet: 'mdi',
      icon: 'mdi-application-outline'
    }
  );
  public static readonly WORKFLOW = new ModuleCard(
    'MODULE.WORKFLOW',
    'WORKFLOW',
    {
      fontSet: 'mdi',
      icon: 'mdi-vector-polyline'
    },
    ['workflows']
  );

  private constructor(public name: string,
                      public code: string,
                      public iconSet: { fontSet: string, icon: string },
                      public link?: string[]) {
  }
}
